import * as React from "react"

export const NoDataChart = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={300}
    height={300}
    {...props}
  >
    <g data-name="Group 112309">
      <text
        data-name="No Data Found"
        transform="translate(184.933 317.105)"
        fill="#98a0ac"
        fontSize={20}
        fontFamily="NotoSans-SemiBold, Nunito Sans"
        fontWeight={600}
      >
        <tspan x={-68} y={0}>
          {"No Data Found"}
        </tspan>
      </text>
      <g data-name="No data-pana">
        <path
          data-name="Rectangle 57221"
          fill="#fff"
          d="m13.129 121.32 68.987-46.148 67.952 101.582-68.987 46.148z"
        />
        <path
          data-name="Path 100298"
          d="m114.417 171.949-.781 4.845-34.3-4.943.781-4.845Z"
          fill="#e0e0e0"
        />
        <path
          data-name="Path 100299"
          d="m97.146 154.665 4.919.707-5.454 33.768-4.925-.713Z"
          fill="#e0e0e0"
        />
        <path
          data-name="Path 100300"
          d="M65.586 111.749c.049.068-6.862 4.784-15.439 10.514s-15.568 10.329-15.617 10.256 6.862-4.784 15.439-10.52 15.537-10.323 15.617-10.25Z"
          fill="#e0e0e0"
        />
        <path
          data-name="Path 100301"
          d="M90.931 105.379c.049.074-11.449 7.845-25.676 17.363s-25.824 17.173-25.861 17.105 11.436-7.852 25.682-17.37 25.805-17.172 25.855-17.098Z"
          fill="#e0e0e0"
        />
        <path
          data-name="Path 100302"
          d="M96.015 112.979c.049.074-11.448 7.852-25.676 17.37s-25.824 17.173-25.861 17.1 11.448-7.845 25.682-17.369 25.805-17.175 25.855-17.101Z"
          fill="#e0e0e0"
        />
        <path
          data-name="Path 100303"
          d="M101.1 120.585c.049.074-11.448 7.852-25.676 17.363S49.6 155.127 49.6 155.053s11.442-7.852 25.676-17.369 25.775-17.173 25.824-17.099Z"
          fill="#e0e0e0"
        />
        <path
          data-name="Path 100304"
          d="M106.167 128.19c.049.074-11.448 7.846-25.676 17.363s-25.824 17.173-25.854 17.1 11.461-7.845 25.707-17.363 25.823-17.174 25.823-17.1Z"
          fill="#e0e0e0"
        />
        <path
          data-name="Rectangle 57222"
          fill="#f5f5f5"
          d="m254.862 181.994 57.938-38.757 57.067 85.31-57.938 38.757z"
        />
        <path
          data-name="Path 100305"
          d="m339.932 224.531-.658 4.07-28.806-4.15.664-4.07Z"
          fill="#e0e0e0"
        />
        <path
          data-name="Path 100306"
          d="m325.428 210.014 4.132.6-4.581 28.357-4.138-.6Z"
          fill="#e0e0e0"
        />
        <path
          data-name="Path 100307"
          d="M298.897 174.004c.049.074-5.749 4.04-12.955 8.854s-13.084 8.663-13.133 8.608 5.755-4.033 12.955-8.854 13.084-8.714 13.133-8.608Z"
          fill="#e0e0e0"
        />
        <path
          data-name="Path 100308"
          d="M320.201 168.623c.049.074-9.6 6.616-21.52 14.6s-21.68 14.418-21.729 14.344 9.6-6.616 21.52-14.609 21.662-14.409 21.729-14.335Z"
          fill="#e0e0e0"
        />
        <path
          data-name="Path 100309"
          d="M324.474 175.005c.049.074-9.6 6.616-21.52 14.609s-21.68 14.412-21.729 14.338 9.567-6.585 21.52-14.578 21.693-14.437 21.729-14.369Z"
          fill="#e0e0e0"
        />
        <path
          data-name="Path 100310"
          d="M328.741 181.381c.049.074-9.6 6.616-21.52 14.609s-21.68 14.412-21.729 14.338 9.6-6.61 21.52-14.609 21.686-14.4 21.729-14.338Z"
          fill="#e0e0e0"
        />
        <path
          data-name="Path 100311"
          d="M333.045 187.782c.049.074-9.6 6.61-21.52 14.6s-21.68 14.412-21.729 14.344 9.6-6.616 21.52-14.609 21.649-14.409 21.729-14.335Z"
          fill="#e0e0e0"
        />
        <path
          data-name="Rectangle 57223"
          fill="#fff"
          d="m157.921 45.098 63.217 33.811-49.787 93.087-63.217-33.812z"
        />
        <path
          data-name="Path 100312"
          d="m160.531 142.873-4.009 1.371-10.182-28.142 4.015-1.377Z"
          fill="#e0e0e0"
        />
        <path
          data-name="Path 100313"
          d="m166.68 122.681 1.463 4.04-27.951 9.573-1.463-4.04Z"
          fill="#e0e0e0"
        />
        <path
          data-name="Path 100314"
          d="M186.539 81.16c-.049.092-6.456-3.24-14.32-7.44s-14.191-7.686-14.142-7.778 6.462 3.24 14.326 7.44 14.185 7.68 14.136 7.778Z"
          fill="#e0e0e0"
        />
        <path
          data-name="Path 100315"
          d="M201.714 97.902c-.049.092-10.662-5.491-23.7-12.463s-23.567-12.7-23.518-12.8 10.655 5.484 23.7 12.463 23.568 12.708 23.518 12.8Z"
          fill="#e0e0e0"
        />
        <path
          data-name="Path 100316"
          d="M197.988 104.868c-.049.092-10.662-5.484-23.7-12.463s-23.567-12.7-23.518-12.8 10.655 5.491 23.7 12.463 23.568 12.708 23.518 12.8Z"
          fill="#e0e0e0"
        />
        <path
          data-name="Path 100317"
          d="M194.262 111.835c-.049.092-10.661-5.484-23.7-12.457s-23.567-12.684-23.518-12.8 10.655 5.484 23.7 12.457 23.568 12.708 23.518 12.8Z"
          fill="#e0e0e0"
        />
        <path
          data-name="Path 100318"
          d="M190.536 118.8c-.049.092-10.661-5.484-23.7-12.457s-23.573-12.7-23.518-12.8 10.655 5.484 23.7 12.457 23.567 12.709 23.518 12.8Z"
          fill="#e0e0e0"
        />
        <path
          data-name="Rectangle 57224"
          opacity={0.2}
          d="M189.275 0h1.586v27.041h-1.586z"
        />
        <g fill="#5078e1">
          <path
            data-name="Path 100319"
            d="M153.036 59.753h74.065s-6.837-32.7-37.595-32.7c-27.352 0-36.47 32.7-36.47 32.7Z"
          />
          <path
            data-name="Rectangle 57225"
            d="M189.275 0h1.586v27.041h-1.586z"
          />
        </g>
        <path
          data-name="Path 100320"
          d="M354.977 270.43c0 .086-79.469.16-177.483.16s-177.495-.055-177.495-.16 79.457-.16 177.495-.16 177.483.068 177.483.16Z"
          fill="#263238"
        />
        <path
          data-name="Path 100321"
          d="M19.651 231.925a7.759 7.759 0 0 1 5.4 2.767 13.62 13.62 0 0 1 2.743 5.533c1.039 3.886.4 8.479-.707 12.346-4.206-1.506-6.806-5.995-7.993-8.356-1.845-3.726-2.945-11.6.535-12.3"
          fill="#5078e1"
        />
        <path
          data-name="Path 100322"
          d="M33.147 257.284a6.6 6.6 0 0 1-.307-6.628 8.768 8.768 0 0 1 5.288-4.249 3.68 3.68 0 0 1 3.111.147 2.816 2.816 0 0 1 1.088 2.65 5.7 5.7 0 0 1-1.23 2.718c-2.047 2.773-4.531 5.079-7.993 5.361"
          fill="#5078e1"
        />
        <path
          data-name="Path 100323"
          d="M33.614 270.274a4 4 0 0 1-.191-.805c-.111-.578-.258-1.322-.437-2.213a23.222 23.222 0 0 1-.455-7.446 14.141 14.141 0 0 1 2.761-6.892 9.419 9.419 0 0 1 1.592-1.617 5.634 5.634 0 0 1 .5-.357.71.71 0 0 1 .184-.111 15.6 15.6 0 0 0-2.121 2.207 14.664 14.664 0 0 0-2.632 6.813 25 25 0 0 0 .375 7.378c.148.941.271 1.7.338 2.232a5.059 5.059 0 0 1 .086.811Z"
          fill="#263238"
        />
        <path
          data-name="Path 100324"
          d="M21.003 237.842a1.438 1.438 0 0 1 .172.314c.111.246.258.553.43.941.375.818.9 2 1.531 3.474 1.267 2.945 2.964 7.04 4.734 11.6s3.277 8.725 4.3 11.756c.529 1.513.941 2.742 1.23 3.6.129.406.227.732.307.984a1.608 1.608 0 0 1 .092.351 1.512 1.512 0 0 1-.148-.332c-.092-.246-.209-.566-.363-.965l-1.3-3.566c-1.1-3.007-2.638-7.163-4.4-11.719s-3.437-8.663-4.654-11.627c-.615-1.457-1.088-2.644-1.439-3.511-.16-.393-.289-.707-.387-.959a2.149 2.149 0 0 1-.105-.341Z"
          fill="#263238"
        />
        <path
          data-name="Path 100325"
          d="M28.615 261.68a15.482 15.482 0 0 0-12-7.458c-1.23-.086-2.742.123-3.3 1.23s.184 2.459 1.033 3.357a13.213 13.213 0 0 0 14.308 3.2"
          fill="#5078e1"
        />
        <path
          data-name="Path 100326"
          d="M18.507 257.555a4.382 4.382 0 0 1 .781.031 7.442 7.442 0 0 1 .9.1c.35.068.762.1 1.193.228a11.931 11.931 0 0 1 1.42.394 14.07 14.07 0 0 1 1.58.615 17.093 17.093 0 0 1 3.332 1.974 16.792 16.792 0 0 1 2.755 2.73 13.828 13.828 0 0 1 .965 1.383 13.486 13.486 0 0 1 .726 1.285 10.7 10.7 0 0 1 .492 1.107 6.977 6.977 0 0 1 .314.861 4.2 4.2 0 0 1 .2.756c-.068 0-.363-1.058-1.193-2.632a13.524 13.524 0 0 0-.744-1.23 15.573 15.573 0 0 0-.971-1.347 16.386 16.386 0 0 0-5.989-4.624c-.535-.234-1.045-.455-1.543-.615a13.439 13.439 0 0 0-1.4-.424c-1.711-.469-2.824-.525-2.818-.592Z"
          fill="#263238"
        />
        <path
          data-name="Path 100327"
          d="M297.606 64.855c-1.808.412-2.687 2.5-2.859 4.341s.061 3.8-.713 5.484c-.873 1.894-2.958 3.3-3.025 5.38-.043 1.273.713 2.459.676 3.744-.062 2.09-2.189 3.689-2.306 5.755-.08 1.506.922 2.945.682 4.433-.184 1.156-1.088 2.066-1.469 3.173-.756 2.213.762 4.642 2.736 5.884a8.971 8.971 0 0 0 13.066-4.169c1.094-2.656.855-5.65.615-8.51q-1.107-13.379-1.648-26.8"
          fill="#263238"
        />
        <path
          data-name="Path 100328"
          d="M292.355 96.323a2.1 2.1 0 0 0 .83-.978 3.56 3.56 0 0 0 .209-1.506 8.275 8.275 0 0 0-.449-1.986 5.724 5.724 0 0 1-.32-2.521 5.794 5.794 0 0 1 1.463-2.521 5.389 5.389 0 0 0 .83-1.26 2.035 2.035 0 0 0 .1-1.476c-.32-1-1.3-1.74-1.752-2.9a3.074 3.074 0 0 1-.1-1.8 7.133 7.133 0 0 1 .615-1.6 13.776 13.776 0 0 0 1.23-2.9c.43-1.949.227-3.812.523-5.343a5.915 5.915 0 0 1 1.555-3.271 3.575 3.575 0 0 1 .812-.615 1.274 1.274 0 0 1 .326-.117 4.728 4.728 0 0 0-1.051.787 6.013 6.013 0 0 0-1.42 3.228 20 20 0 0 0-.172 2.459 15.139 15.139 0 0 1-.283 2.884 13.817 13.817 0 0 1-1.23 2.964 4.059 4.059 0 0 0-.48 3.154c.406 1.058 1.383 1.789 1.758 2.921a2.386 2.386 0 0 1-.117 1.691A5.82 5.82 0 0 1 294.31 87a5.834 5.834 0 0 0-1.433 2.373 5.533 5.533 0 0 0 .283 2.416 8.378 8.378 0 0 1 .406 2.041 3.45 3.45 0 0 1-.277 1.562 1.882 1.882 0 0 1-.615.775.972.972 0 0 1-.319.156Z"
          fill="#455a64"
        />
        <path
          data-name="Path 100329"
          d="m287.547 110.901-5.534 15.986-23.143 1.23-3.861 8.608 24.164 2.459a9.13 9.13 0 0 0 12.063-5.368l6.45-18Z"
          fill="#b78876"
        />
        <path
          data-name="Path 100330"
          d="M335.389 261.742s-16.958-53.873-17.32-55.619c-.326-1.586 6.149-40.353 6.972-50.418l-22.915.855v.227l-9.739.541 8.718 110.137h10.545l-1.045-36.553a356.507 356.507 0 0 0 15.826 35.249Z"
          fill="#b78876"
        />
        <path
          data-name="Path 100331"
          d="M311.034 244.022c0-.332-.129-12.248-.129-12.248-.129.713-4.04-10.342-3.947-11.012.049-.347 4.076 23.26 4.076 23.26Z"
          fill="#a36957"
        />
        <path
          data-name="Path 100332"
          d="M306.516 215.524a2.387 2.387 0 0 0-.068.67 16.694 16.694 0 0 0 0 1.845 12.28 12.28 0 0 0 .1 1.26c.049.455.117.935.221 1.433a25.441 25.441 0 0 0 .867 3.209c.762 2.232 1.611 4.181 2.207 5.6.283.615.529 1.2.738 1.666a2.653 2.653 0 0 0 .308.615 2.332 2.332 0 0 0-.185-.615c-.141-.406-.357-.99-.615-1.709-.541-1.439-1.353-3.406-2.109-5.614a26.647 26.647 0 0 1-.879-3.16c-.111-.492-.184-.965-.252-1.408s-.117-.861-.148-1.23c-.074-.762-.1-1.377-.123-1.808a2.784 2.784 0 0 0-.068-.75Z"
          fill="#a36957"
        />
        <path
          data-name="Path 100333"
          d="M300.908 268.019v-.993l10.8-.473.031 4.089-.664.043c-2.97.172-15.095.676-17.074.08-2.218-.661 6.907-2.746 6.907-2.746Z"
          fill="#455a64"
        />
        <path
          data-name="Path 100334"
          d="M311.882 270.399a1.387 1.387 0 0 1-.184 0l-.529.037-1.955.086c-1.648.068-3.929.129-6.444.141s-4.8-.031-6.456-.08l-1.949-.08h-.719a1.135 1.135 0 0 1 .184 0h.535l1.955.037c1.648 0 3.929.049 6.444.037s4.8-.055 6.45-.1l1.955-.049h.713Z"
          fill="#263238"
        />
        <path
          data-name="Path 100335"
          d="M297.385 270.743a4.713 4.713 0 0 0-.369-.928 4.428 4.428 0 0 0-.67-.744 1.426 1.426 0 0 1 .781.676 1.469 1.469 0 0 1 .258.996Z"
          fill="#263238"
        />
        <path
          data-name="Path 100336"
          d="M300.57 269.126a2.435 2.435 0 0 1-.338-.412c-.16-.246-.258-.461-.227-.48s.178.16.338.406.258.467.227.486Z"
          fill="#263238"
        />
        <path
          data-name="Path 100337"
          d="M301.442 268.689c0 .031-.2-.086-.381-.252s-.32-.32-.3-.344.2.086.381.252.326.289.3.344Z"
          fill="#263238"
        />
        <path
          data-name="Path 100338"
          d="M301.99 267.644a1.3 1.3 0 0 1-.566.074 1.23 1.23 0 0 1-.559-.055 1.278 1.278 0 0 1 .559-.074 1.228 1.228 0 0 1 .566.055Z"
          fill="#263238"
        />
        <path
          data-name="Path 100339"
          d="M302.175 266.931a1.144 1.144 0 0 1-.615.184 1.161 1.161 0 0 1-.615-.086 3.539 3.539 0 0 1 .615-.049 3.2 3.2 0 0 1 .615-.049Z"
          fill="#263238"
        />
        <path
          data-name="Path 100340"
          d="M300.207 268.186a1.886 1.886 0 0 1-.695 0 3.967 3.967 0 0 1-.732-.16 1.981 1.981 0 0 1-.424-.172.387.387 0 0 1-.172-.215.271.271 0 0 1 .1-.277 1.279 1.279 0 0 1 1.8.83.468.468 0 0 1 0 .185 1.981 1.981 0 0 0-.32-.615 1.267 1.267 0 0 0-.615-.381 1.1 1.1 0 0 0-.824.062c-.1.08-.061.209.055.283a2.212 2.212 0 0 0 .393.166 5.163 5.163 0 0 0 .707.178c.462.097.727.097.727.116Z"
          fill="#263238"
        />
        <path
          data-name="Path 100341"
          d="M300.028 268.222a.652.652 0 0 1-.086-.48 1.142 1.142 0 0 1 .191-.5.7.7 0 0 1 .572-.357.283.283 0 0 1 .215.32.731.731 0 0 1-.117.307 2.542 2.542 0 0 1-.326.424 1.007 1.007 0 0 1-.394.277 4.335 4.335 0 0 0 .326-.344 2.383 2.383 0 0 0 .289-.412c.092-.148.16-.412 0-.443s-.344.16-.449.3a1.124 1.124 0 0 0-.2.449 2.169 2.169 0 0 0-.025.467Z"
          fill="#263238"
        />
        <path
          data-name="Path 100342"
          d="M311.656 267.46s-.307 0-.793.031a3.406 3.406 0 0 0-2.81 2.256c-.16.461-.172.775-.2.769s0-.08 0-.215a2.768 2.768 0 0 1 .111-.584 3.365 3.365 0 0 1 1.082-1.6 3.314 3.314 0 0 1 1.8-.707 2.571 2.571 0 0 1 .615 0 .775.775 0 0 1 .195.05Z"
          fill="#263238"
        />
        <path
          data-name="Path 100343"
          d="M306.485 269.538a6.03 6.03 0 0 1-1.574.154 5.8 5.8 0 0 1-1.568-.135c0-.037.7 0 1.568 0s1.568-.056 1.574-.019Z"
          fill="#263238"
        />
        <path
          data-name="Path 100344"
          d="M308.587 269.519s-.055.148-.129.307-.111.307-.148.3-.055-.166.031-.357.219-.28.246-.25Z"
          fill="#263238"
        />
        <path
          data-name="Path 100345"
          d="M309.38 268.529a.68.68 0 0 1-.154.246c-.111.111-.221.184-.252.16s.043-.135.154-.252.222-.189.252-.154Z"
          fill="#263238"
        />
        <path
          data-name="Path 100346"
          d="M310.512 268.075c0 .037-.148.037-.307.092s-.271.141-.3.117.062-.172.258-.24.361-.006.349.031Z"
          fill="#263238"
        />
        <path
          data-name="Path 100347"
          d="M311.318 267.854c0 .037-.043.092-.135.123s-.172.037-.184 0 .049-.092.135-.123.171-.031.184 0Z"
          fill="#263238"
        />
        <path
          data-name="Path 100348"
          d="m326.215 267.066-.406-.9 9.659-4.855 1.7 3.689-.616.311c-2.638 1.371-13.49 6.794-15.543 7.065-2.264.328 5.206-5.31 5.206-5.31Z"
          fill="#455a64"
        />
        <path
          data-name="Path 100349"
          d="m337.208 264.736-.16.1-.474.246-1.746.885c-1.476.732-3.529 1.722-5.823 2.767s-4.4 1.937-5.921 2.57l-1.814.732-.492.191a.7.7 0 0 1-.178.055l.166-.08.486-.215 1.8-.769c1.519-.652 3.609-1.562 5.9-2.607s4.353-2.017 5.841-2.73l1.758-.842.486-.228Z"
          fill="#263238"
        />
        <path
          data-name="Path 100350"
          d="M324.148 270.989a4.528 4.528 0 0 0-.719-.7 4.264 4.264 0 0 0-.916-.406 1.728 1.728 0 0 1 1.635 1.107Z"
          fill="#263238"
        />
        <path
          data-name="Path 100351"
          d="M326.363 268.21a2.2 2.2 0 0 1-.48-.234c-.246-.16-.424-.314-.406-.344s.234.074.48.234.424.313.406.344Z"
          fill="#263238"
        />
        <path
          data-name="Path 100352"
          d="M326.965 267.46c0 .031-.209 0-.449-.074s-.418-.166-.412-.2a.917.917 0 0 1 .455.074c.235.053.418.139.406.2Z"
          fill="#263238"
        />
        <path
          data-name="Path 100353"
          d="M327.052 266.279a1.435 1.435 0 0 1-.486.3 1.3 1.3 0 0 1-.535.178 1.449 1.449 0 0 1 .48-.3 1.34 1.34 0 0 1 .541-.178Z"
          fill="#263238"
        />
        <path
          data-name="Path 100354"
          d="M326.928 265.556a1.673 1.673 0 0 1-.5.424 1.07 1.07 0 0 1-.615.185 3.246 3.246 0 0 1 .559-.3c.303-.17.525-.342.556-.309Z"
          fill="#263238"
        />
        <path
          data-name="Path 100355"
          d="M325.668 267.506a1.992 1.992 0 0 1-.615.283 4.828 4.828 0 0 1-.738.154 1.849 1.849 0 0 1-.455 0 .363.363 0 0 1-.246-.123.271.271 0 0 1 0-.3 1.267 1.267 0 0 1 1.58-.307 1.23 1.23 0 0 1 .393.326c.074.1.1.16.1.166a1.846 1.846 0 0 0-.535-.412 1.229 1.229 0 0 0-.695-.1 1.076 1.076 0 0 0-.726.394c-.068.117 0 .215.166.234a2.449 2.449 0 0 0 .424 0 4.848 4.848 0 0 0 .725-.129c.352-.097.622-.201.622-.186Z"
          fill="#263238"
        />
        <path
          data-name="Path 100356"
          d="M325.495 267.614a.683.683 0 0 1-.271-.406 1.156 1.156 0 0 1-.037-.535.694.694 0 0 1 .381-.56c.154-.049.51.264.535.381s-.178.055-.191.154a2.148 2.148 0 0 1-.123.51.961.961 0 0 1-.246.418 4.513 4.513 0 0 0 .16-.443 3.15 3.15 0 0 0 .092-.5c0-.172 0-.436-.2-.393s-.252.283-.3.455a1.067 1.067 0 0 0 0 .486 2.706 2.706 0 0 0 .2.433Z"
          fill="#263238"
        />
        <path
          data-name="Path 100357"
          d="M335.795 262.148a4.359 4.359 0 0 0-.713.357 3.351 3.351 0 0 0-1.635 3.209c.037.492.154.775.129.787a.782.782 0 0 1-.092-.2 3.185 3.185 0 0 1-.129-.578 3.253 3.253 0 0 1 1.679-3.3 2.919 2.919 0 0 1 .547-.234.754.754 0 0 1 .215-.049Z"
          fill="#263238"
        />
        <path
          data-name="Path 100358"
          d="M331.927 266.17a8.782 8.782 0 0 1-2.859 1.3c0-.037.646-.283 1.432-.615s1.409-.717 1.427-.685Z"
          fill="#263238"
        />
        <path
          data-name="Path 100359"
          d="M333.839 265.289c.031 0 0 .154 0 .332v.338a.5.5 0 0 1-.123-.338c0-.201.092-.35.123-.332Z"
          fill="#263238"
        />
        <path
          data-name="Path 100360"
          d="M334.153 264.059c.031 0 0 .141-.037.289s-.129.258-.16.246 0-.141.037-.289.123-.258.16-.246Z"
          fill="#263238"
        />
        <path
          data-name="Path 100361"
          d="M335.001 263.158c0 .037-.123.092-.246.209s-.191.24-.221.228 0-.185.135-.326a.4.4 0 0 1 .332-.111Z"
          fill="#263238"
        />
        <path
          data-name="Path 100362"
          d="M335.647 262.652a.246.246 0 0 1-.074.166c-.074.068-.141.1-.166.08s0-.1.074-.166.141-.104.166-.08Z"
          fill="#263238"
        />
        <path
          data-name="Path 100363"
          d="m323.552 137.505-1.8-21.95 9.223.166s.424-3.24-.935-10.336a11.977 11.977 0 0 0-6.985-8.608v-.061l-.283-.074a26.333 26.333 0 0 0-8.46-2.207l-11.344.129s-8.663-1.107-13.441 5.1c-1.844 2.379-7.569 18.667-7.569 18.667l13.619 6.554-1.273-9.032s.258 6.548 1.094 8.608a750.322 750.322 0 0 1 1.844 4.747l-.178 10.834Z"
          fill="#5078e1"
        />
        <path
          data-name="Path 100364"
          d="m317.3 112.37-1.685 7.169h15.882l-1.045-12.026Z"
          fill="#5078e1"
        />
        <path
          data-name="Path 100365"
          d="M331.497 119.539a12.729 12.729 0 0 0-2.1-.209c-1.3-.074-3.074-.141-5.091-.129s-3.794.1-5.1.2a12.049 12.049 0 0 0-2.1.258 13.317 13.317 0 0 0 2.115 0 197.068 197.068 0 0 1 10.164-.069 13.305 13.305 0 0 0 2.109-.049Z"
          fill="#263238"
        />
        <path
          data-name="Path 100366"
          d="M316.611 107.458a9.584 9.584 0 0 0-.049 1.845c0 1.125.049 2.675.117 4.39s.148 3.271.221 4.39a9.161 9.161 0 0 0 .2 1.845 9.614 9.614 0 0 0 .049-1.845c0-1.125-.049-2.681-.117-4.4s-.148-3.265-.221-4.39a9.044 9.044 0 0 0-.2-1.835Z"
          fill="#263238"
        />
        <g data-name="Group 112178" opacity={0.3}>
          <path
            data-name="Path 100367"
            d="M302.162 113.667s3.529 26.174 13.453 25.479c0 0 4.47-.049 5.9-3.019v-1.168Z"
          />
        </g>
        <g data-name="Group 112179" opacity={0.3}>
          <path
            data-name="Path 100368"
            d="m316.611 109.001-1.9 12.832 1.23 2.25 2.029-4.4-.861-.025Z"
          />
        </g>
        <path
          data-name="Path 100369"
          d="M297.194 129.217a2.458 2.458 0 0 1-.271-.615c-.154-.4-.357-.984-.615-1.715a52.944 52.944 0 0 1-1.519-5.81 41.189 41.189 0 0 1-.75-5.958c-.037-.769-.049-1.39-.037-1.845a2.454 2.454 0 0 1 .043-.664c.049 0 .086.947.215 2.459a54.723 54.723 0 0 0 .842 5.909c.455 2.287 1 4.335 1.42 5.8.2.683.363 1.267.5 1.746a3 3 0 0 1 .172.689Z"
          fill="#263238"
        />
        <path
          data-name="Path 100370"
          d="M301.203 136.736a3.174 3.174 0 0 1-.547-1.23 2.95 2.95 0 0 1-.24-1.353 3.209 3.209 0 0 1 .547 1.26 3.076 3.076 0 0 1 .24 1.323Z"
          fill="#263238"
        />
        <path
          data-name="Path 100371"
          d="M302.574 136.639a5.657 5.657 0 0 1-.055-3.837 12.77 12.77 0 0 1 0 1.918 12.632 12.632 0 0 1 .055 1.919Z"
          fill="#263238"
        />
        <path
          data-name="Path 100372"
          d="M295.86 125.183c-.043.074-3.21-1.426-7.077-3.357s-6.972-3.566-6.935-3.646 3.209 1.426 7.077 3.357 6.972 3.566 6.935 3.646Z"
          fill="#263238"
        />
        <path
          data-name="Path 100373"
          d="M301.442 96.685c.068-3.111.086-6.382.086-6.382s-3.99-.769-4.685-6.019c-.664-5 1.193-16.755 1.193-16.755 5.829-2.2 11.885-.2 15.875 4.519l-.99 25.252a5.424 5.424 0 0 1-5.866 5.023 5.731 5.731 0 0 1-5.613-5.638Z"
          fill="#b78876"
        />
        <path
          data-name="Path 100374"
          d="M297.729 76.918a.676.676 0 0 0 .615.695.646.646 0 0 0 .707-.615.67.67 0 0 0-.615-.689.615.615 0 0 0-.707.609Z"
          fill="#263238"
        />
        <path
          data-name="Path 100375"
          d="M297.483 76.038c.08.086.615-.277 1.322-.252s1.23.394 1.316.307-.037-.2-.264-.375a1.844 1.844 0 0 0-1.057-.35 1.728 1.728 0 0 0-1.052.307c-.228.167-.308.32-.265.363Z"
          fill="#263238"
        />
        <path
          data-name="Path 100376"
          d="M305.052 77.373a.67.67 0 0 0 .615.695.615.615 0 0 0 .707-.615.664.664 0 0 0-.615-.689.615.615 0 0 0-.707.609Z"
          fill="#263238"
        />
        <path
          data-name="Path 100377"
          d="M305.003 76.494c.08.092.615-.271 1.322-.252s1.23.394 1.322.307-.043-.2-.271-.369a1.764 1.764 0 0 0-1.051-.357 1.789 1.789 0 0 0-1.057.307c-.222.167-.302.321-.265.364Z"
          fill="#263238"
        />
        <path
          data-name="Path 100378"
          d="M302.248 81.775a4.647 4.647 0 0 0-1.173-.241c-.185 0-.357-.068-.381-.191a.9.9 0 0 1 .135-.547l.578-1.383a24.042 24.042 0 0 0 1.322-3.64 24.372 24.372 0 0 0-1.611 3.523c-.191.486-.381.953-.56 1.4a1.077 1.077 0 0 0-.111.719.461.461 0 0 0 .3.283 1.261 1.261 0 0 0 .314.049 4.692 4.692 0 0 0 1.187.028Z"
          fill="#263238"
        />
        <path
          data-name="Path 100379"
          d="M301.529 90.303a13.317 13.317 0 0 0 7.046-1.691s-1.789 3.548-7.009 2.927Z"
          fill="#a36957"
        />
        <path
          data-name="Path 100380"
          d="M307.315 74.397c-.148.228-.7.129-1.316 0s-1.156-.234-1.23-.5.572-.615 1.4-.449 1.294.752 1.146.949Z"
          fill="#263238"
        />
        <path
          data-name="Path 100381"
          d="M300.139 73.352c-.055.264-.646.363-1.322.394s-1.273 0-1.353-.271.492-.652 1.31-.689 1.42.314 1.365.566Z"
          fill="#263238"
        />
        <path
          data-name="Path 100382"
          d="M302.261 83.503a.357.357 0 0 0-.4.184.4.4 0 1 0 .246-.2"
          fill="#a36957"
        />
        <path
          data-name="Path 100383"
          d="M302.427 83.577c0-.031-.117-.209-.43-.141a.553.553 0 0 0-.393.387.589.589 0 0 0 .91.652.516.516 0 0 0 .221-.51c-.061-.326-.3-.375-.314-.332s.086.154.068.344a.289.289 0 0 1-.148.227.314.314 0 0 1-.314 0 .326.326 0 0 1-.111-.3.3.3 0 0 1 .166-.227c.175-.106.326-.057.345-.1Z"
          fill="#263238"
        />
        <path
          data-name="Path 100384"
          d="M311.526 78.215c-.615 1.439-2.14 2.552-1.931 4.107.135 1 .781 1.937.658 2.945-.16 1.23-1.469 2.14-1.66 3.4-.227 1.543 1.279 2.742 1.875 4.181.879 2.1-.24 4.464-.271 6.763a7.218 7.218 0 0 0 6.394 7.022 3.841 3.841 0 0 0 3.689-1.513c.615-1 .48-2.263.836-3.363.541-1.648 2.109-2.853 2.459-4.55.615-3.074-3.136-5.657-2.89-8.8.1-1.347.935-2.515 1.285-3.818a5.608 5.608 0 0 0-1.094-4.974c-.928-1.1-2.269-1.845-3.074-3.025-.891-1.359-.922-3.074-1.23-4.679a11.793 11.793 0 0 0-18.728-6.9s-.891 4.052 3.271 4.734 6.087-.1 6.554 1.562a4.4 4.4 0 0 0 1.23 3.806c1.699 1.824 3.316 1.43 2.627 3.102Z"
          fill="#263238"
        />
        <path
          data-name="Path 100385"
          d="M318.135 106.32a1.467 1.467 0 0 1-.381-.037 6.013 6.013 0 0 1-1.058-.289 7.507 7.507 0 0 1-3.222-2.379 8.523 8.523 0 0 1-1.365-2.459 9.741 9.741 0 0 1-.56-3.154 13.026 13.026 0 0 1 .443-3.511 15.022 15.022 0 0 1 .615-1.777 18.181 18.181 0 0 0 .67-1.765 3.284 3.284 0 0 0 0-1.808 10.03 10.03 0 0 0-.695-1.685 11.064 11.064 0 0 1-.719-1.666 3.6 3.6 0 0 1-.129-1.765 12.512 12.512 0 0 1 1.365-2.9 5.478 5.478 0 0 0 .553-2.619 6.179 6.179 0 0 0-1.371-3.628 10.82 10.82 0 0 0-1.039-1.015 4.2 4.2 0 0 1 1.137.935 6.148 6.148 0 0 1 1.5 3.689 5.681 5.681 0 0 1-.541 2.742 12.693 12.693 0 0 0-1.316 2.834 5.245 5.245 0 0 0 .836 3.24 9.59 9.59 0 0 1 .725 1.74 3.622 3.622 0 0 1 0 1.967 19.293 19.293 0 0 1-.707 1.826 14.482 14.482 0 0 0-.615 1.74 12.67 12.67 0 0 0-.449 3.425 8.891 8.891 0 0 0 1.808 5.46 7.549 7.549 0 0 0 3.074 2.4c.919.367 1.448.422 1.441.459Z"
          fill="#455a64"
        />
        <path
          data-name="Path 100386"
          d="M317.521 75.295a4.345 4.345 0 0 1-.916.135 9.536 9.536 0 0 1-2.533-.068 4.827 4.827 0 0 1-3.2-1.937 10.446 10.446 0 0 1-.836-2.066 3.431 3.431 0 0 0-1.4-1.728 9.909 9.909 0 0 0-4.3-1.125 7.507 7.507 0 0 1-3.584-1.119 3.547 3.547 0 0 1-1.47-2.047 2.058 2.058 0 0 1-.043-.695c0-.16.037-.24.049-.24a4.35 4.35 0 0 0 .117.9 3.518 3.518 0 0 0 1.476 1.894 7.434 7.434 0 0 0 3.486 1.008 10.028 10.028 0 0 1 4.451 1.15 3.738 3.738 0 0 1 1.525 1.888 10.293 10.293 0 0 0 .793 2.017 4.642 4.642 0 0 0 2.988 1.845 10.613 10.613 0 0 0 2.459.166 6.218 6.218 0 0 1 .938.022Z"
          fill="#455a64"
        />
        <path
          data-name="Path 100387"
          d="M315.997 70.29a2.048 2.048 0 0 1-.719.1 4.384 4.384 0 0 1-3.074-1.23 5.648 5.648 0 0 1-.953-1.273 5.3 5.3 0 0 0-2.238-2.564 7.378 7.378 0 0 0-3.443-.3 10.563 10.563 0 0 1-2.939 0 3.689 3.689 0 0 1-1.844-.812 2.043 2.043 0 0 1-.357-.406q-.111-.16-.092-.166a4.1 4.1 0 0 0 .529.473 3.873 3.873 0 0 0 1.777.689 11.155 11.155 0 0 0 2.878-.049 7.378 7.378 0 0 1 3.6.307 3.536 3.536 0 0 1 1.469 1.23 15.819 15.819 0 0 1 .891 1.488 5.853 5.853 0 0 0 .892 1.23 4.305 4.305 0 0 0 1.051.781 4.563 4.563 0 0 0 1.844.51 4.742 4.742 0 0 1 .728-.008Z"
          fill="#455a64"
        />
        <path
          data-name="Path 100388"
          d="M319.968 104.992c-.031 0 .166-.406.393-1.168a10.574 10.574 0 0 0 .406-3.3 10.036 10.036 0 0 0-1.31-4.691c-.449-.805-1.131-1.525-1.691-2.41a4.3 4.3 0 0 1-.615-1.482 3.314 3.314 0 0 1 .135-1.66 19.7 19.7 0 0 0 1.094-2.933 4.25 4.25 0 0 0-.8-2.662 13.105 13.105 0 0 1-.658-1.23 4.5 4.5 0 0 1-.351-1.285 11.141 11.141 0 0 1 .074-2.343 6.217 6.217 0 0 0-.3-3.271 2.977 2.977 0 0 0-.725-.959.128.128 0 0 1 .074.037.749.749 0 0 1 .2.141 2.194 2.194 0 0 1 .572.732 6.076 6.076 0 0 1 .4 3.339 11.772 11.772 0 0 0-.031 2.293 5.9 5.9 0 0 0 1 2.386 8.168 8.168 0 0 1 .67 1.31 3.073 3.073 0 0 1 .184 1.549 18.1 18.1 0 0 1-1.1 2.988 3.074 3.074 0 0 0-.129 1.506 4.094 4.094 0 0 0 .578 1.371c.523.855 1.23 1.586 1.679 2.429a10.145 10.145 0 0 1 1.279 4.839 9.951 9.951 0 0 1-.516 3.339 6.428 6.428 0 0 1-.357.849 1.129 1.129 0 0 1-.154.283Z"
          fill="#455a64"
        />
        <path
          data-name="Path 100389"
          d="M294.925 219.557s-4.144-39.252-4.384-53.756 6.524-28.819 6.524-28.819l26.488-1.1s5.238 14.713 5.331 20.9c.184 12.014-3.191 23.875-2.8 33.4l.885 29.39"
          fill="#263238"
        />
        <path
          data-name="Path 100390"
          d="M327.856 171.297a4.228 4.228 0 0 1-.436.332l-.24.166-.258.252a4.261 4.261 0 0 0-.615.658 14.737 14.737 0 0 0-2.072 5.251 17.652 17.652 0 0 1-1.336 3.741 6.545 6.545 0 0 1-.615.928c-.111.147-.215.307-.344.449l-.406.406a6.586 6.586 0 0 1-1.992 1.279c-1.482.652-3.16.959-4.685 1.728a7.378 7.378 0 0 0-3.4 3.874c-.75 1.666-1.23 3.412-1.845 5.048a9.1 9.1 0 0 1-2.767 4.193 7.6 7.6 0 0 1-4.3 1.359c-1.426.086-2.748.043-3.935.221a6.214 6.214 0 0 0-2.964 1.119 4.155 4.155 0 0 0-1.377 1.943 2.951 2.951 0 0 0-.1 1.506c.074.344.166.51.148.516a1.549 1.549 0 0 1-.209-.5 2.822 2.822 0 0 1 .049-1.556 4.182 4.182 0 0 1 1.383-2.047 6.3 6.3 0 0 1 3.074-1.23c1.23-.2 2.539-.172 3.947-.264a7.379 7.379 0 0 0 4.175-1.328 8.927 8.927 0 0 0 2.65-4.07c.615-1.617 1.064-3.369 1.845-5.066a7.686 7.686 0 0 1 3.554-4.027c1.586-.787 3.265-1.088 4.71-1.715a6.447 6.447 0 0 0 1.918-1.23l.387-.387c.123-.135.227-.289.338-.43a5.937 5.937 0 0 0 .572-.892 17.633 17.633 0 0 0 1.359-3.689 14.277 14.277 0 0 1 2.189-5.275 4.007 4.007 0 0 1 .615-.652c.1-.086.184-.172.271-.24l.252-.16a4.257 4.257 0 0 1 .46-.211Z"
          fill="#fafafa"
        />
        <path
          data-name="Path 100391"
          d="M328.017 153.135a2.871 2.871 0 0 1 .037.523 6.438 6.438 0 0 1-.184 1.506 9.683 9.683 0 0 1-2.994 4.624 17.786 17.786 0 0 1-3.074 2.269c-1.187.7-2.5 1.371-3.843 2.134a19.848 19.848 0 0 0-3.923 2.761 15.15 15.15 0 0 0-2.973 4.174 38.215 38.215 0 0 1-2.576 4.544 10.858 10.858 0 0 1-1.685 1.845 10.167 10.167 0 0 1-2.035 1.346 24.525 24.525 0 0 1-4.113 1.58 36.908 36.908 0 0 0-3.615 1.23 13.841 13.841 0 0 0-2.755 1.476 8.54 8.54 0 0 0-1.728 1.593 7.906 7.906 0 0 0-1.039 1.722 3.248 3.248 0 0 1 .172-.5 6.15 6.15 0 0 1 .769-1.3 8.282 8.282 0 0 1 1.721-1.66 14.04 14.04 0 0 1 2.773-1.537 36.9 36.9 0 0 1 3.621-1.26 25.44 25.44 0 0 0 4.058-1.586 10.48 10.48 0 0 0 1.937-1.3 10.915 10.915 0 0 0 1.623-1.808 39.556 39.556 0 0 0 2.552-4.513 15.268 15.268 0 0 1 3.074-4.255 19.814 19.814 0 0 1 4-2.791c1.353-.756 2.662-1.414 3.849-2.109a17.758 17.758 0 0 0 3.074-2.2 9.752 9.752 0 0 0 3.025-4.495 9.41 9.41 0 0 0 .258-2Z"
          fill="#fafafa"
        />
        <path
          data-name="Path 100392"
          d="M290.677 167.855a.462.462 0 0 1-.055-.123 3.215 3.215 0 0 1-.117-.363 2.94 2.94 0 0 1 .062-1.476 6.091 6.091 0 0 1 3.892-3.591c1.094-.375 2.33-.615 3.621-.935a6.819 6.819 0 0 0 5.011-3.732 19.766 19.766 0 0 0 .916-2.207 24.056 24.056 0 0 1 1.949-4.716 7.513 7.513 0 0 1 4.009-3.117 36.4 36.4 0 0 1 4.605-1.168 15.266 15.266 0 0 0 4-1.365 8.422 8.422 0 0 0 2.705-2.459 9.148 9.148 0 0 0 1.722-4.98 14.151 14.151 0 0 0-.129-1.967 6.4 6.4 0 0 1 .252 1.967 9.056 9.056 0 0 1-1.66 5.109 8.509 8.509 0 0 1-2.761 2.539 15.329 15.329 0 0 1-4.064 1.42 36.63 36.63 0 0 0-4.562 1.174 7.219 7.219 0 0 0-3.849 2.994 24.109 24.109 0 0 0-1.924 4.648 19.117 19.117 0 0 1-.941 2.244 8.122 8.122 0 0 1-1.377 1.906 7.992 7.992 0 0 1-3.843 1.937c-1.3.332-2.533.541-3.609.9a5.957 5.957 0 0 0-3.849 3.412 3.118 3.118 0 0 0-.117 1.426 3.074 3.074 0 0 1 .111.523Z"
          fill="#fafafa"
        />
        <path
          data-name="Path 100393"
          d="M325.742 201.056a2.359 2.359 0 0 1 .043.387 4.09 4.09 0 0 1-.117 1.107 6.278 6.278 0 0 1-2.324 3.32 10.244 10.244 0 0 1-2.459 1.451c-.941.4-1.98.719-3.074 1.058a25.393 25.393 0 0 0-3.326 1.23 9.5 9.5 0 0 0-2.958 2.207c-.9.935-1.672 1.961-2.533 2.871a11.54 11.54 0 0 1-2.835 2.213 12.487 12.487 0 0 1-5.847 1.525 11.646 11.646 0 0 1-4.021-.67 7.666 7.666 0 0 1-1.021-.437 1.619 1.619 0 0 1-.338-.191 2.6 2.6 0 0 1 .363.129 10.931 10.931 0 0 0 1.033.381 12.3 12.3 0 0 0 3.984.559 12.427 12.427 0 0 0 5.706-1.556 11.483 11.483 0 0 0 2.748-2.17c.842-.9 1.611-1.918 2.527-2.878a9.873 9.873 0 0 1 3.123-2.275 25.438 25.438 0 0 1 3.376-1.23 32.194 32.194 0 0 0 3.074-1.021 10.311 10.311 0 0 0 2.4-1.383 6.271 6.271 0 0 0 2.343-3.173 7.812 7.812 0 0 0 .133-1.454Z"
          fill="#fafafa"
        />
        <path
          data-name="Path 100394"
          d="m322.722 119.564-5.128.123a8.3 8.3 0 0 1-1.156 2.908 87.644 87.644 0 0 1-8.43-21.4c.123-.4.264-.842.443-1.334a5.682 5.682 0 0 0-.068-2.25c-.147-.892-.393-2.09-.467-2.644-.227-1.7-.5-1.961-1.094-1.771-.8.264.332 4.753-.326 4.851-.357.049-.787-1.488-.91-2.748s-.7-5.146-1.113-5.4c-.615-.381-1.15.221-.99 1.476s.35 5.066-.314 5.122-1.23-6.388-1.23-6.388.1-1.4-.67-1.371c-1.389.061-.3 6.849-.184 7.5.086.443-.615.529-.7.043s-.406-6.437-1.844-6.388c-1.095 0 .842 5.589.227 6.88s-1.033-4.378-2.072-4.3c-.387.031-.676.1.037 3.308a72.674 72.674 0 0 0 2.459 7.507c1.648 8.885 8.878 37.309 20.21 32.107 6.345-2.914 8.915-15.814 8.915-15.814Z"
          fill="#b78876"
        />
        <path
          data-name="Path 100395"
          d="M300.865 96.654a.3.3 0 0 0 .147 0 .326.326 0 0 0 .228-.357c0-.381-.074-.935-.16-1.654a23.1 23.1 0 0 1-.283-2.619c0-.516 0-1.07.031-1.654a6.071 6.071 0 0 1 .092-.885c.049-.277.234-.615.449-.56h.037a.491.491 0 0 1 .455.418 2.407 2.407 0 0 1 .086.824 47.947 47.947 0 0 0 .658 5.134c.049.227.1.461.172.695a2.638 2.638 0 0 0 .123.35 1.962 1.962 0 0 0 .1.184.338.338 0 0 0 .258.16.455.455 0 0 0 .387-.326 1.762 1.762 0 0 0 .117-.375 6.253 6.253 0 0 0 .1-.75 22.411 22.411 0 0 0-.043-3.074 6.946 6.946 0 0 1-.061-1.543.861.861 0 0 1 .3-.572.326.326 0 0 1 .264-.031.5.5 0 0 1 .147.061.2.2 0 0 1 .068.092 7.841 7.841 0 0 1 .424 1.543c.111.541.2 1.1.289 1.66s.166 1.125.234 1.7a12.506 12.506 0 0 0 .283 1.752 6.767 6.767 0 0 0 .277.867 1.632 1.632 0 0 0 .258.437.363.363 0 0 0 .363.135.381.381 0 0 0 .252-.277 3.075 3.075 0 0 0 .068-.959 8.774 8.774 0 0 0-.068-.91c-.043-.516-.092-1.027-.111-1.531a5.979 5.979 0 0 1 0-.744 1.232 1.232 0 0 1 .08-.32.3.3 0 0 1 .055-.092h.08c.406-.166.541.4.652.855s.154.971.252 1.457c.16.965.369 1.931.473 2.853a3.4 3.4 0 0 1-.049 1.328c-.148.443-.3.879-.437 1.316v.08a70.852 70.852 0 0 0 2.748 8.891c.971 2.625 1.949 4.919 2.8 6.763s1.629 3.289 2.158 4.261l.615 1.1a2.067 2.067 0 0 0 .24.369 2.455 2.455 0 0 0-.191-.393l-.615-1.125c-.5-.99-1.23-2.459-2.066-4.3s-1.783-4.138-2.73-6.763a73.421 73.421 0 0 1-2.693-8.866v.086c.141-.43.283-.867.43-1.3a3.519 3.519 0 0 0 .074-1.469c-.111-.965-.314-1.9-.473-2.871-.092-.48-.154-.971-.252-1.476a2.708 2.708 0 0 0-.129-.762.725.725 0 0 0-.338-.344.781.781 0 0 0-.486 0h-.1a.4.4 0 0 0-.141.08.542.542 0 0 0-.154.215 1.392 1.392 0 0 0-.1.418 5.8 5.8 0 0 0 0 .8c0 .516.074 1.033.117 1.549 0 .3.049.615.062.891a2.991 2.991 0 0 1-.043.83c0 .061-.049.049 0 .08l-.037-.037a1.231 1.231 0 0 1-.184-.332 6.035 6.035 0 0 1-.264-.818 11.432 11.432 0 0 1-.277-1.7q-.1-.867-.24-1.715a30.23 30.23 0 0 0-.3-1.672 7.486 7.486 0 0 0-.467-1.642.523.523 0 0 0-.191-.215 1.065 1.065 0 0 0-.228-.1.682.682 0 0 0-.523.074 1.149 1.149 0 0 0-.455.8 2.982 2.982 0 0 0 0 .842c0 .264.061.523.08.781a22.776 22.776 0 0 1 .055 3.025 5.261 5.261 0 0 1-.092.713 1.372 1.372 0 0 1-.092.32.376.376 0 0 1-.068.111c0 .055-.043 0-.037.074v-.08a1.245 1.245 0 0 1-.074-.129c-.043-.1-.08-.209-.117-.314-.068-.221-.117-.449-.166-.67a48.841 48.841 0 0 1-.695-5.091 2.679 2.679 0 0 0-.1-.916.861.861 0 0 0-.24-.406.614.614 0 0 0-.455-.172h.037a.535.535 0 0 0-.535.252 1.358 1.358 0 0 0-.184.48 6.2 6.2 0 0 0-.086.922v1.672a21.455 21.455 0 0 0 .338 2.632c.1.713.184 1.267.221 1.642a.289.289 0 0 1-.178.32.927.927 0 0 0-.226.017Z"
          fill="#a36957"
        />
        <path
          data-name="Path 100396"
          d="M260.819 128.03a13.164 13.164 0 0 0-3.56.412c-3.179.836-8.657 4.156-8.885 8.257h3.984s-2.232 4.747-1.58 4.3a51.189 51.189 0 0 0 5.085-4.581Z"
          fill="#b78876"
        />
        <path
          data-name="Path 100397"
          d="M315.13 56.566c-.092 0-.449-3.283-.805-7.378s-.579-7.378-.493-7.378.449 3.283.805 7.378.579 7.378.493 7.378Z"
          fill="#263238"
        />
        <path
          data-name="Path 100398"
          d="M332.598 42.062c.068.049-2.619 3.953-6.007 8.719s-6.2 8.608-6.271 8.534 2.619-3.953 6.007-8.719 6.193-8.583 6.271-8.534Z"
          fill="#263238"
        />
        <path
          data-name="Path 100399"
          d="M339.852 59.758c0 .086-3.123.805-7.009 1.6s-7.058 1.377-7.077 1.291 3.117-.805 7.009-1.6 7.031-1.376 7.077-1.291Z"
          fill="#263238"
        />
        <path
          data-name="Path 100400"
          d="m130.76 144.207-21.766 111.778-2.828 14.635 145.1-.7c6.517-.031 12.3-5.816 14.381-14.412l25.742-105.523c1.592-6.524-1.9-13.311-6.843-13.305l-146.9.154c-3.197-.011-6.062 3.014-6.886 7.373Z"
          fill="#5078e1"
        />
        <g data-name="Group 112180" opacity={0.5}>
          <path
            data-name="Path 100401"
            d="m130.76 144.207-21.766 111.778-2.828 14.635 145.1-.7c6.517-.031 12.3-5.816 14.381-14.412l25.742-105.523c1.592-6.524-1.9-13.311-6.843-13.305l-146.9.154c-3.197-.011-6.062 3.014-6.886 7.373Z"
          />
        </g>
        <path
          data-name="Path 100402"
          d="m237.369 248.399-15.371-123.837a9.729 9.729 0 0 0-9.444-8.842l-33.694.1a9.223 9.223 0 0 0-6.659 2.951l-15.986 17.019-93.7.5c-5.724.031-10.127 5.454-9.37 11.541l14.271 114.454a9.741 9.741 0 0 0 9.432 8.842l163.335-.326c18.187.375 19.927-4.993 19.927-4.993-20.884 4.621-22.741-17.378-22.741-17.409Z"
          fill="#5078e1"
        />
        <g data-name="Group 112181" opacity={0.5} fill="#fff">
          <path
            data-name="Path 100403"
            d="m166.938 223.634-5.509 5.915-42.425-38.17 5.509-5.915Z"
          />
          <path
            data-name="Path 100404"
            d="m159.123 184.154 6.087 5.478-38.385 41.226-6.093-5.478Z"
          />
        </g>
        <path
          data-name="Path 100405"
          d="M260.69 63.809a1.137 1.137 0 0 1-.695-1l-.246-5.706a1.144 1.144 0 0 1 1.408-1.168 3.578 3.578 0 0 0 2.779-.547 3.2 3.2 0 0 0 1.433-2.1 3.277 3.277 0 0 0-.689-2.459 3.689 3.689 0 0 0-2.422-1.457 4.3 4.3 0 0 0-4.366 3.074 1.15 1.15 0 0 1-2.213-.615 6.616 6.616 0 0 1 6.843-4.777 5.94 5.94 0 0 1 3.99 2.355 5.613 5.613 0 0 1 1.125 4.224 5.533 5.533 0 0 1-2.459 3.64 5.976 5.976 0 0 1-3.111 1.015l.191 4.4a1.15 1.15 0 0 1-1.6 1.1Z"
          fill="#5078e1"
        />
        <path
          data-name="Path 100406"
          d="M262.375 66.145a.935.935 0 1 1-.319-.646.941.941 0 0 1 .319.646Z"
          fill="#5078e1"
        />
        <path
          data-name="Path 100407"
          d="M240.935 55.76a2.882 2.882 0 0 0 .055-.369c0-.271.068-.615.117-1.1a13.326 13.326 0 0 1 .3-1.771c.08-.344.123-.726.246-1.113s.246-.805.381-1.23a21.2 21.2 0 0 1 3.074-5.86 20.6 20.6 0 0 1 6.462-5.62 20.291 20.291 0 0 1 4.556-1.881 20.628 20.628 0 0 1 5.257-.689 20.39 20.39 0 0 1 2.8.148c.473.049.941.172 1.414.252a10.527 10.527 0 0 1 1.414.344 19.676 19.676 0 0 1 5.466 2.478 20.561 20.561 0 0 1 8.128 10.206 20.133 20.133 0 0 1 1.23 7.015 19.775 19.775 0 0 1-1.285 7.218l-.277.7-.037.092.037.092c1.543 3.548 3.074 7.034 4.519 10.409l.258-.3-9.223-3.535-.111-.043-.092.086a20.274 20.274 0 0 1-25.295 2.441 21.011 21.011 0 0 1-5.183-4.827 20.419 20.419 0 0 1-3.935-9.432l-.191-1.6c-.056-.469 0-.848-.031-1.174a5.492 5.492 0 0 1 0-.719.123.123 0 1 0-.037 0v1.916c0 .467.1 1 .166 1.611a22 22 0 0 0 1.051 4.341 22.511 22.511 0 0 0 2.816 5.226 21.194 21.194 0 0 0 5.22 4.919 20.474 20.474 0 0 0 25.658-2.373l-.2.043 9.223 3.554.461.178-.2-.473c-1.463-3.376-2.976-6.856-4.513-10.409v.178l.283-.719a20.107 20.107 0 0 0 1.316-7.378 20.569 20.569 0 0 0-1.23-7.169 20.9 20.9 0 0 0-8.307-10.4 19.858 19.858 0 0 0-5.607-2.521 9.771 9.771 0 0 0-1.439-.338c-.48-.086-.953-.209-1.433-.252a21.147 21.147 0 0 0-2.834-.16 20.634 20.634 0 0 0-5.337.726 21.02 21.02 0 0 0-4.617 1.931 20.639 20.639 0 0 0-6.5 5.749 21.022 21.022 0 0 0-3.031 5.952c-.129.443-.252.867-.363 1.23a10.868 10.868 0 0 0-.234 1.125 11.69 11.69 0 0 0-.258 1.783c-.037.473-.062.836-.08 1.107a1.563 1.563 0 0 0-.028.405Z"
          fill="#263238"
        />
      </g>
    </g>
  </svg>
)


